import { reflectionStorage, store } from '@/store'
import { useOnMount } from '@seiue/util'
import { getUrlParams } from 'packages/utils'
import { FC } from 'react'

/**
 * 登录界面
 *
 * @returns login page
 */
export const Logout: FC = () => {
  useOnMount(() => {
    const redirect = getUrlParams('redirect')
    // 清除登录的缓存
    store.set(reflectionStorage, undefined)

    if (redirect) {
      location.href = redirect
    } else {
      location.href = '/'
    }
  })

  return null
}
